import React, { useState } from 'react';
import { Button } from 'src/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { ProjectDeleteContent } from 'src/components/ProjectSettings/Popups/ProjectDeleteContent';
import { DeleteIcon } from 'src/assets/img/delete-icon';
import type { Project } from 'src/services/projectsService';

export const DeleteProjectModal = ({
  disabled = false,
  redirect = undefined,
  setOpenModal = (_open: boolean) => {},
  trigger = (
    <Button
      variant="pill-outline-red"
      size="pill"
      className={clsx(
        disabled && 'pointer-events-none opacity-50',
        'card-header-button cursor-pointer max-md:mt-0 flex items-center gap-2',
      )}
    >
      <p className="max-md:text-xs text-delete font-bold max-md:font-medium">
        Delete <span className="max-md:hidden">project</span>
      </p>
      <DeleteIcon />
    </Button>
  ),
  project = {},
}: {
  disabled?: boolean;
  redirect?: boolean;
  setOpenModal?: (open: boolean) => void;
  trigger?: React.ReactNode;
  project?: Partial<Pick<Project, 'id' | 'name' | 'ai_reply_generation' | 'ai_text_lense'>>;
}) => {
  const [open, setOpen] = useState(false);

  const closePopup = () => {
    setOpen(false);
    setOpenModal(false);
  };

  const onOpenChangeHandler = (open: boolean) => {
    setOpen(open);
    setOpenModal(open);
  };

  return (
    <Dialog onOpenChange={onOpenChangeHandler} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent closeButtonHidden>
        <DialogHeader>
          <DialogTitle className="opacity-80 text-lg font-medium font-jamjuree">
            Delete project
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <ProjectDeleteContent redirect={redirect} close={closePopup} project={project} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
